import { render, staticRenderFns } from "./DedicationDesignsComponent.vue?vue&type=template&id=36f9a806&scoped=true&"
import script from "./DedicationDesignsComponent.vue?vue&type=script&lang=js&"
export * from "./DedicationDesignsComponent.vue?vue&type=script&lang=js&"
import style0 from "./DedicationDesignsComponent.vue?vue&type=style&index=0&id=36f9a806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f9a806",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VScrollYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCard,VIcon,VImg,VItem,VItemGroup,VScrollYTransition})
